// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://sctc.aclarian.com',
  appName: 'Sumter County Tax Collector | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub5192d793b50444e9483bdd33b2112953',
  datadogApplicationId: '32eb0379-b71c-4fc1-b083-8d6c983795ff',
  datadogService: 'invoicing_sctc_prod',
  ApiKey: 'uyVdGoxaf3FIF5BJ',
  env: 'PROD',
  version: packageInfo.version,
};
